import { render } from "./tender.vue?vue&type=template&id=77529ea2"
import script from "./tender.vue?vue&type=script&lang=js"
export * from "./tender.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/tender/tender.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77529ea2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77529ea2', __exports__)) {
    console.log('reload')
    api.reload('77529ea2', __exports__)
  }
  
  module.hot.accept("./tender.vue?vue&type=template&id=77529ea2", () => {
    console.log('re-render')
    api.rerender('77529ea2', render)
  })

}


export default __exports__